var React = require('react');

function DownloadArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M46.8117 0V79.8816","stroke":"#142641","strokeWidth":"3","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M81.2056 45.4873L46.8116 79.8813L12.4176 45.4873","stroke":"#142641","strokeWidth":"3","strokeMiterlimit":"10","key":1}),React.createElement("path",{"d":"M27.8055 117.231H2V93.7983","stroke":"#142641","strokeWidth":"3","strokeMiterlimit":"10","key":2}),React.createElement("path",{"d":"M65.8046 117.231H91.61V93.7983","stroke":"#142641","strokeWidth":"3","strokeMiterlimit":"10","key":3})]);
}

DownloadArrow.defaultProps = {"width":"94","height":"119","viewBox":"0 0 94 119","fill":"none"};

module.exports = DownloadArrow;

DownloadArrow.default = DownloadArrow;
